<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar este serviço de patrimônio do tipo <b>{{this.entry.typeValue}}</b>?</p>
       <!-- <b>{{this.entry.totalPrice  | formatCurrency }}</b>?</p> -->
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
    modelNameSingular: String,
  },
  methods: {
    destroyServerEntry: function(serviceProvision) {
      // console.log("confirmou a deleção");
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DESTROY_SERVICE_PROVISION_MUTATION,
            variables: {
              id: serviceProvision.id,
            }
          })
          .then(response => {
            var errors = response.data.destroyServiceProvision.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}
const DESTROY_SERVICE_PROVISION_MUTATION = gql `
  mutation($id: ID!) {
    destroyServiceProvision(id: $id) {
      serviceProvision {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>